// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"Services_Wrapper__1ut0n","ServicesWrapper":"Services_ServicesWrapper__1mryW"};